<template>
	<div v-if="stateManage.length > 0">
		<div class="small-title">
			<div>订单管理</div>
		</div>

		<div class="order-box">
			<div class="daily-content">
				<div class="daily-table">
					<div class="">
						<el-tabs v-model="passVlue.type" @tab-click="cutManage">
							<el-tab-pane v-for="(item, index) in stateManage" :key="index" :name="item.id">
								<div slot="label">
									{{ item.name }}
								</div>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>

			<div class="order-list">
				<div class="order-list-item">
					<div class="list-item-time">
						<div class="text">下单时间:</div>
						<el-date-picker
							v-model="orderTime"
							type="daterange"
							format="yyyy-MM-dd"
							value-format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
						>
						</el-date-picker>
					</div>
					<div class="list-item-search" @keyup.enter="checkOrder">
						<el-input
							placeholder="请输入项目名称、项目编号、设计师或申请人"
							v-model="searchValue"
							clearable
							@input="inputChange"
						>
						</el-input>
						<el-button type="danger" @click="checkOrder">查询</el-button>
					</div>
					<el-button class="pull-order" type="danger" @click="pullOrderExcel"
						>导出订单列表</el-button
					>
				</div>
				<div class="order-list-from">
					<el-table
						:header-cell-style="{ background: '#FAFAFA' }"
						ref="filterTable"
						:data="orderList.list"
					>
						<el-table-column prop="order_name" label="订单编号" width="140">
							<template slot-scope="scope">
								<el-tooltip
									class="item"
									effect="dark"
									:content="scope.row.order_name"
									placement="top-start"
								>
									<div class="scope-order-name" @click="permissions[40].trigger(scope.row)">
										{{ scope.row.order_name }}
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="order_pro_name" label="项目名称" min-width="160" max-width="180">
							<template slot-scope="scope">
								<el-tooltip
									class="item"
									effect="dark"
									:content="scope.row.order_pro_name"
									placement="top-start"
								>
									<div class="scope-order-name" @click="permissions[40].trigger(scope.row)">
										{{ scope.row.order_pro_name }}
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column sortable prop="order_apply_name" width="120" label="申请人">
						</el-table-column>
						<el-table-column sortable prop="area_name" label="区域" width="80"> </el-table-column>
						<!-- <el-table-column
							prop="pay_price"
							label="支付订单金额"
							width="140"
							:formatter="payPriceChange"
						></el-table-column> -->
						<el-table-column prop="order_tag_name" label="状态" width="80" sortable>
							<template slot-scope="scope">
								<div class="tag_name-box" :data-title="scope.row.order_tag_name">
									{{ scope.row.order_tag_name }}
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="order_status" label="订单状态" align="center" width="100">
							<template slot-scope="scope">
								<!-- 12  已取消     20 15已验收 已完成 -->
								<p
									class=""
									:style="
										scope.row.order_status == 12
											? 'color: rgba(153, 153, 153, 1)'
											: scope.row.order_status == 20 || scope.row.order_status == 15
											? 'color: rgba(18, 177, 66, 1)'
											: 'color: rgba(24, 144, 255, 1)'
									"
								>
									{{ scope.row.order_status_text }}
								</p></template
							>
						</el-table-column>
						<el-table-column prop="base_create_time" sortable label="下单时间" width="130">
							<template slot-scope="scope">
								<el-tooltip
									class="item"
									effect="dark"
									:disabled="
										scope.row.base_create_time == '' || scope.row.base_create_time == '-'
											? true
											: false
									"
									:content="scope.row.base_create_time"
									placement="top-start"
								>
									<div class="scope-order-name">
										{{ scope.row.base_create_time }}
									</div>
								</el-tooltip>
							</template>
						</el-table-column>
						<!-- <el-table-column sortable prop="pay_time" label="付款时间" width="130">
							<template slot-scope="scope">
								<el-tooltip
									class="item"
									effect="dark"
									:disabled="scope.row.pay_time == '' || scope.row.pay_time == '-' ? true : false"
									:content="scope.row.pay_time"
									placement="top-start"
								>
									<div class="scope-order-name">
										{{ scope.row.pay_time }}
									</div>
								</el-tooltip>
							</template>
						</el-table-column> -->
						<el-table-column sortable prop="pay_time" label="交付日期" width="130">
							<template slot-scope="scope">
								<el-tooltip
									class="item"
									effect="dark"
									:disabled="scope.row.submit_case_time == '' || scope.row.submit_case_time == '-' ? true : false"
									:content="scope.row.submit_case_time"
									placement="top-start"
								>
									<div class="scope-order-name">
										{{ scope.row.submit_case_time }}
									</div>
								</el-tooltip>
							</template>
						</el-table-column>

						<el-table-column sortable prop="design_name" label="主责设计师" width="130">
						</el-table-column>
						<el-table-column sortable prop="child_design_name" label="协助设计师" width="130">
						</el-table-column>
						<!-- width="280" -->
						<el-table-column align="right" prop="name" label="操作" min-width="120">
							<template slot-scope="scope">
								<div class="operation-content-box">
									<div
										v-for="(item, index) in scope.row.permissions"
										@click="permissions[item].trigger(scope.row)"
										:key="index"
										class="operation-box"
									>
										<div class="operation-list">
											{{ permissions[item].name }}
										</div>
										<span v-if="index < scope.row.permissions.length - 1">|</span>
									</div>
									<!-- <div
                    v-for="(item, index) in permissions"
                    @click="item.trigger(scope.row)"
                    :key="index"
                    class="operation-box"
                  >
                    <div class="operation-list">
                      {{ item.name }}
                    </div>
                    <span>|</span>
                  </div> -->
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="order-list-page">
					<el-pagination
						background
						layout="prev, pager, next,sizes,jumper"
						:total="orderList.total.total"
						:current-page="orderList.total.current_page"
						:page-size="passVlue.limit"
						@size-change="sizeChange"
						@current-change="currentChange"
					>
					</el-pagination>
				</div>
			</div>
		</div>
		<order-operation @changParams="changParams" ref="child" :popType="popType"></order-operation>
	</div>
</template>

<script>
	import orderOperation from '../components/orderOperation.vue';
	import { $orderList, $pullOrderExport } from '@/api';
	export default {
		components: {
			orderOperation: orderOperation,
		},
		computed: {},
		watch: {},
		data() {
			return {
				searchValue: '', //搜索的内容
				orderTime: '', //订单时间
				selectItem: {}, //选中的行
				//订单接口传参
				passVlue: {
					search: '',
					type: 0,
					time: '',
					order_create_time: 2, //1=升序,2=降序
					order_pay_time: 2, //:1=升序,2=降序
					page: 1,
					limit: 10,
				},
				// 设计师分页
				designPaging: {
					id: null,
					page: 1,
					limit: 13,
				},
				//订单列表
				orderList: {
					list: [],
					total: {
						total: 0,
					},
				},
				//状态管理
				stateManage: [
					{ name: '全部', id: '0' },
					{ name: '待审批', id: '3' },
					{ name: '待分配', id: '4' },
					{ name: '待接单', id: '5' },
					{ name: '待报价', id: '6' },
					{ name: '待支付', id: '7' },
					{ name: '设计中', id: '8' },
					{ name: '待审核', id: '9' },
					{ name: '待验收', id: '18' },
					{ name: '已验收', id: '20' },
					{ name: '待修改', id: '10' },
					{ name: '已完成', id: '15' },
					{ name: '已取消', id: '12' },
					{ name: '撤单/售后', id: '99' },
				],
				score: null,
				popType: 0, //1分配主责设计师 2拒绝分配 3订单报价 4支付成功 5上传方案 6评价方案 7分配协助设计师 8取消订单 9审核不通过 修改方案 10审核方案 11验收方案 12 支付报价 新增 13拒绝协助  14撤单 15继续设计
				permissions: {
					39: {
						name: '取消',
						trigger: (item) => {
							this.popType = 8;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.$data = this.$refs.child.$options.data();
							// console.log(this.$refs.child.$options.data());
						},
					},
					40: {
						name: '详情',
						trigger: (item) => {
							this.$router.push({
								path: '/orderdetails',
								query: { id: window.btoa(item.id) },
							});
						},
					},
					41: {
						name: '支付',
						trigger: (item) => {
							this.popType = 12;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.postOrderPayInfo();
						},
					},
					42: {
						name: '验收',
						trigger: (item) => {
							this.popType = 11;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getPlanList();
						},
					},
					43: {
						name: '评价',
						trigger: (item) => {
							this.popType = 6;
							this.$refs.child.setSelectItem(item);
						},
					},
					44: {
						name: '确定报价',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.postFirmPrice();
						},
					},
					45: {
						name: '审核',
						trigger: (item) => {
							this.popType = 10;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getPlanList();
						},
					},
					46: {
						name: '分配',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getOrderDesignList(1, 1);
						},
					},
					47: {
						name: '再次分配',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getOrderDesignList(1, 1);
						},
					},
					48: {
						name: '分配协助',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getOrderDesignList(7, 1);
						},
					},
					49: {
						name: '拒绝协助',
						trigger: (item) => {
							this.popType = 13;
							this.$refs.child.setSelectItem(item);
						},
					},
					50: {
						name: '接受协助',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.agreeAllocation(2);
						},
					},
					51: {
						name: '拒绝分配',
						trigger: (item) => {
							this.popType = 2;
							this.$refs.child.setSelectItem(item);
						},
					},
					52: {
						name: '接受分配',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.agreeAllocation(1);
						},
					},
					53: {
						name: '申请协助',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.postRrequestAssist();
						},
					},
					54: {
						name: '上传方案',
						trigger: (item) => {
							this.popType = 5;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getPlanList();
						},
					},
					55: {
						name: '修改',
						trigger: (item) => {
							this.popType = 9;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.postPlanEdit();
						},
					},
					56: {
						name: '报价',
						trigger: (item) => {
							this.popType = 3;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.getReportPrice();
						},
					},
					57: {
						name: '继续设计',
						trigger: (item) => {
							this.$refs.child.setSelectItem(item);
							this.$refs.child.continueDesign();
						},
					},
					58: {
						name: '撤单',
						trigger: (item) => {
							this.popType = 14;
							this.$refs.child.setSelectItem(item);
							this.$refs.child.postOrderPayInfo();
							this.$refs.child.$data = this.$refs.child.$options.data();
						},
					},
					60: {
						name: '审批',
						trigger: (item) => {
							this.popType = 15;
							this.$refs.child.setSelectItem(item);
						},
					},
				},
				//设计师列表
				designList: {},
				//选中的设计师
				designItem: {},
				//支付报价
				orderPrice: {},
				pullOrderExcelFile: '',
			};
		},

		beforeCreate() {},
		created() {},
		beforeMount() {},
		mounted() {
			let type = this.$route.query.type;
			if (type) {
				this.passVlue.type = type;
				this.cutManage();
				return;
			}
			this.postOrderList();
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		methods: {
			// 订单导出
			pullOrderExcel() {
				if (this.orderList.list.length == 0) {
					this.$message.error(`列表为空，不支持导出`);
					return;
				}
				const fn = () => {
					const loading = this.$loading({
						lock: true,
						// text: "有文件正在上传不可“保存草稿箱”与“确认下单”",
						text: '正在整合文档请稍等....',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)',
					});

					$pullOrderExport({
						search: this.searchValue,
						time: this.orderTime ? this.orderTime[0] + '~' + this.orderTime[1] : '',
						type: this.passVlue.type,
						// order_create_time:'',
						// order_pay_time:'',
						// tag:'',
					})
						.then((res) => {
							loading.close();
							this.pullOrderExcelFile = res.data;
							let a = document.createElement('a');
							a.href = this.pullOrderExcelFile;
							a.download = this.pullOrderExcelFile;
							a.target = '_blank';
							a.click();
						})
						.catch(() => {
							loading.close();
						});
				};

				this.$confirm('是否导出订单列表？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				})
					.then(() => {
						fn();
					})
					.catch(() => {});
			},

			// 1 重置数据  默认关闭窗口
			changParams(params) {
				switch (params.type) {
					case 1:
						this.postOrderList();
						this.popType = 0;
						break;
					default:
						this.popType = 0;
					// this.closePop()
				}
			},

			//查询订单
			checkOrder() {
				// if (!this.searchValue.trim()) return;

				if (this.orderTime) {
					this.passVlue.time = this.orderTime[0] + '~' + this.orderTime[1];
				} else {
					this.passVlue.time = '';
				}
				this.passVlue.page = 1;
				this.passVlue.search = this.searchValue;
				this.postOrderList();
			},
			//每页多少条 列表分页
			sizeChange(limit) {
				if (limit == this.passVlue.limit) return;
				this.passVlue.limit = limit;
				this.postOrderList();
			},
			currentChange(page) {
				if (page == this.passVlue.page) return;
				this.passVlue.page = page;
				this.postOrderList();
			},

			//获取订单列表
			postOrderList() {
				$orderList(this.passVlue).then((res) => {
					console.log(res,'888');
					
					this.orderList = res.data;
				});
			},
			//切换审核状态
			cutManage(tab, event) {
				// if (type == this.passVlue.type) return;
				// this.passVlue.type = type;
				this.$router.push({ query: { type: this.passVlue.type } });
				this.passVlue.page = 1;
				this.postOrderList();
			},

			resetDateFilter() {
				this.$refs.filterTable.clearFilter('date');
			},
			clearFilter() {
				this.$refs.filterTable.clearFilter();
			},
			formatter(row, column) {
				return row.address;
			},
			filterTag(value, row) {
				return row.tag === value;
			},
			filterHandler(value, row, column) {
				const property = column['property'];
				return row[property] === value;
			},

			// 查询输入框
			inputChange(val) {
				let timer;
				if (val.length == 0) {
					timer = setTimeout(() => {
						this.checkOrder();
					}, 300);
				} else {
					if (timer) {
						clearTimeout(timer);
					}
				}
			},

			// 格式化数据
			payPriceChange(row, column, cellValue, index) {
				let params = '';
				if (cellValue && cellValue != '-') {
					params = '￥' + cellValue;
				} else {
					params = '-';
				}
				return params;
			},
		},
	};
</script>

<style lang="scss" scoped>
	// 分页 颜色
	::v-deep {
		.el-pagination.is-background .el-pager li:not(.disabled) {
			background-color: #fff; // 进行修改未选中背景和字体
			border: 1px solid #d9d9d9;
			color: rgba(0, 0, 0, 0.65);
		}
		.el-pagination.is-background .el-pager li:not(.disabled).active {
			background-color: #e60000; // 进行修改选中项背景和字体
			color: #ffffff;
		}
		.btn-prev,
		.btn-next {
			border: 1px solid #d9d9d9;
			background-color: #fff !important;
		}

		// 数字
		.el-pagination.is-background .el-pager li {
			font-weight: 400;
		}

		// 每页条数框
		.el-select .el-input.is-focus .el-input__inner {
			border-color: $theme-color;
			border-radius: 4px;
		}
		.el-pagination__sizes .el-input .el-input__inner:hover {
			border-color: $theme-color;
		}
		.el-input__inner:focus {
			border-color: $theme-color;
		}

		// 页码框
		.el-date-table td.today span {
			color: $theme-color;
		}
	}

	// // 日期颜色
	// ::v-deep {
	//   .el-date-table span {
	//     color: $theme-color !important;
	//   }
	// }

	.small-title {
		box-sizing: border-box;
		padding: 18px 20px;
		font-size: 20px;
		font-weight: bold;
		line-height: 1;
		color: rgba(0, 0, 0, 1);
		background: rgba(255, 255, 255, 1);
	}

	.daily-content {
		position: relative;
		box-sizing: border-box;
		// padding: calc(var(--proportion) * 24px);
		// padding-bottom: 0px;
		width: 100%;

		.daily-table {
			position: relative;
			// padding-bottom: 40px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			width: 100%;
			// min-height: 600px;
			background: rgba(255, 255, 255, 1);
			border-radius: 2px;

			::v-deep .el-tabs__item {
				padding: 0px 20px;
			}
			::v-deep .el-tabs__header {
				margin: 0;
			}
		}
	}
	::v-deep .list-item-time {
		.el-date-editor .el-range-separator {
			width: 25px;
			font-size: 26px;
		}
	}
	::v-deep .list-item-search {
		margin-bottom: 4px;
		width: 420px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;
		.el-input {
			width: 340px;
			height: 40px;
		}
	}
	::v-deep .order-list-from {
		.el-table .ascending .sort-caret.ascending {
			border-bottom-color: rgba(230, 50, 65, 1);
		}
	}
	.order-box {
		margin: 20px;
		.daily-content {
			.daily-table {
			}
		}

		.order-list {
			background-color: #fff;
			padding: 30px 30px 10px 30px;
			.order-list-item {
				position: relative;
				display: flex;
				flex-wrap: wrap;
				.list-item-time {
					display: flex;
					margin-bottom: 4px;
					margin-right: 48px;
					align-items: center;
					flex-shrink: 0;
					.text {
						font-size: 16px;

						font-weight: 400;
						line-height: 22px;
						color: #333333;
						opacity: 1;
						margin-right: 12px;
					}
				}
			}
			.order-list-from {
				margin-top: 25px;
			}
			.operation-list {
				font-size: 14px;

				font-weight: 400;
				line-height: 22px;
				color: #e60000;
				opacity: 1;
				cursor: pointer;
			}
			.operation-content-box {
				display: flex;
				justify-content: flex-end;
				flex-wrap: wrap;
			}
			.operation-box {
				display: flex;
				justify-content: flex-end;
				span {
					margin: 0 8px;
					color: rgba(233, 233, 233, 1);
				}
			}
		}
	}

	.order-list-page {
		display: flex;
		justify-content: end;
		margin-top: 30px;
	}
	::v-deep .cell {
		font-size: 16px;

		font-weight: 400;
		line-height: 22px;
	}

	// 标签页
	::v-deep {
		.el-tabs__item:hover {
			color: #e60000;
		}
		.el-tabs__item.is-active {
			color: #e60000;
		}
		.el-tabs__active-bar {
			background: #e60000;
		}

		// 按钮颜色
		.el-button--danger {
			color: #fff;
			background-color: $theme-color;
			border-color: $theme-color;
		}
	}

	// 日期输入框
	::v-deep {
		.el-range-editor.is-active,
		.el-range-editor.is-active:hover {
			border-color: $theme-color;
		}
	}
	.scope-order-name {
		cursor: pointer;
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		user-select: none;
	}
	.tag_name-box {
		display: inline-block;
		min-width: 44px;
		padding: 3px 4px;
		background: #eee;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 400;
		line-height: 22px;
		color: #333;
		text-align: center;
	}
	.tag_name-box[data-title='正常'] {
		color: #12b142;
		background: rgba(18, 177, 66, 0.1);
	}
	.tag_name-box[data-title='修改'] {
		color: #1890ff;
		background: rgba(24, 144, 255, 0.1);
	}
	.tag_name-box[data-title='被驳回'] {
		color: #f5a522;
		background: rgba(245, 165, 34, 0.1);
	}
	.tag_name-box[data-title='紧急'] {
		color: #e60000;
		background: rgba(230, 50, 65, 0.1);
	}

	.pull-order {
		margin-bottom: 4px;
		margin-left: 20px;
	}
</style>
